/**
 * The shop's time, on whatever device is showing it.
 *
 * CLAUDE.md §3: UTC in the database, Europe/Berlin on screen. Until
 * 2026-09-26 the client used the device's own zone — right on the two
 * tablets, wrong on a laptop set to anything else — and placed timeline
 * bars by hours *elapsed* since midnight, which on the two
 * daylight-saving days is an hour away from what the wall clock says.
 */
export const SHOP_ZONE = "Europe/Berlin";

const parts = new Intl.DateTimeFormat("en-GB", {
  timeZone: SHOP_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hourCycle: "h23",
});

function wall(at: Date) {
  const p = Object.fromEntries(parts.formatToParts(at).map((x) => [x.type, x.value]));
  return {
    y: Number(p.year),
    m: Number(p.month),
    d: Number(p.day),
    h: Number(p.hour),
    min: Number(p.minute),
    s: Number(p.second),
  };
}

/** YYYY-MM-DD of this moment in Berlin. */
export function berlinDay(at: Date): string {
  const w = wall(at);
  return `${w.y}-${String(w.m).padStart(2, "0")}-${String(w.d).padStart(2, "0")}`;
}

/** HH:MM of this moment in Berlin. */
export function berlinClock(at: string | Date): string {
  const w = wall(new Date(at));
  return `${String(w.h).padStart(2, "0")}:${String(w.min).padStart(2, "0")}`;
}

/**
 * Where a moment falls on `date`'s wall clock, in hours: 10:00 is 10
 * whatever happened at 02:00 that night. Past midnight counts on (24.5
 * is 00:30 the next day), before it counts back.
 */
export function berlinHoursInto(date: string, at: string | Date): number {
  const w = wall(new Date(at));
  const [y, m, d] = date.split("-").map(Number);
  const days = (Date.UTC(w.y, w.m - 1, w.d) - Date.UTC(y!, m! - 1, d!)) / 86_400_000;
  return days * 24 + w.h + w.min / 60 + w.s / 3600;
}
